import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Modal,
  ModalProps,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  background: theme.palette.bg.secondary,
  borderRadius: 24,
  padding: theme.spacing(2, 3, 3),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(3, 2, 5),
    borderRadius: 0,
  },
}));

const CloseButtonSX: SxProps<Theme> = {
  position: 'absolute',
  top: 18,
  right: 26,
  cursor: 'pointer',
  color: 'rgba(255, 255, 255, 0.56)',
  '&:hover': {
    color: (theme) => theme.palette.grey[50],
  },
};

export type BasicModalProps = ModalProps & {
  children: React.ReactNode;
  title?: React.ReactNode;
};

const WrappedModal: React.FC<BasicModalProps> = ({
  children,
  title,
  ...props
}) => {
  return (
    <Modal {...props}>
      <>
        <ModalContent>
          <CloseIcon
            sx={CloseButtonSX}
            onClick={(e) => props.onClose?.(e, 'backdropClick')}
          />
          {title && (
            <>
              <Typography
                variant="h5"
                fontWeight={500}
                sx={{
                  textTransform: 'uppercase',
                }}
              >
                {title}
              </Typography>
            </>
          )}
          {children}
        </ModalContent>
      </>
    </Modal>
  );
};

export default WrappedModal;
